const RESOURCE_NAMES = {
  driftwood: 'Driftwood',
  scrap_metal: 'Scrap Metal',
  stone: 'Stone',
  cloth_scraps: 'Cloth Scraps',
  herbs: 'Herbs',
  cooking_ingredient: 'Forgetful Mussel Bed',
};

export const COLLECTING_LOCK_REASON =
  'Finish the active gathering action before moving, travelling, or gathering again.';

export function isCollectingAction(action) {
  return String(action || '').trim().toUpperCase() === 'COLLECTING';
}

export function resourceNodeName(node) {
  if (node?.itemName) return String(node.itemName);
  const key = String(node?.resourceKey || '');
  if (key.startsWith('map-item:')) return 'Resource';
  if (RESOURCE_NAMES[key]) return RESOURCE_NAMES[key];
  const words = key.replace(/[_-]+/g, ' ').trim();
  return words
    ? words.replace(/\b\w/g, character => character.toUpperCase())
    : 'Resource';
}

const GATHERING_ERROR_MESSAGES = {
  already_reserved: 'Another player is already gathering from this node.',
  depleted: 'This resource node is depleted. Return after it respawns.',
  invalid_action: 'You cannot gather during your current action.',
  action_not_allowed: 'Stop your current action before gathering.',
  collection_in_progress: 'Another gathering action is already in progress.',
  inventory_full: 'Your Pack has no room for the gathered resources.',
  not_near: 'Move onto or next to the resource node first.',
  out_of_range: 'Move onto or next to the resource node first.',
  resource_node_too_far: 'Move onto or next to the resource node first.',
  resource_node_unavailable: 'This resource node is reserved or depleted.',
  shared_world_required: 'Leave your private Camp before gathering resources.',
};

export function gatheringErrorMessage(error, fallback) {
  const code = String(
    error?.details?.code
    ?? error?.details?.Code
    ?? error?.code
    ?? error?.Code
    ?? '',
  ).toLowerCase();
  return GATHERING_ERROR_MESSAGES[code]
    || error?.message
    || fallback;
}
